import StyledSearchInput from './StyledSearchInput'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { useDebounce } from 'packages/core'
import { Box, Typography, styled } from '@mui/material'
import { InfoOutline } from '../../eid-icons'

const TextRoot = styled(Box)(() => ({
    whiteSpace: 'nowrap',
    marginRight: '0.6rem',
    marginLeft: '0.8rem',
}))
const NotificationRoot = styled(Box)(() => ({
    width: 'fit-content !important',
    height: '2.4rem !important',
    margin: '0.8rem 0 0.6rem 0 !important',
    padding: '0 0 0 0.8rem !important',
    borderRadius: '0.5rem !important',
    border: 'solid 0.1rem #f0cf9e !important',
    background: '#ffe6b2 !important',
    '& div': {
        background: '#ffe6b2 !important',
    },
}))

const ThresholdSearchInput = ({
    sx = {},
    sxNotify = '',
    handleSearch,
    placeholder,
    minCharacterLength = 3,
    hideSearchInfoMessage = false,
    handleInputBlur = () => {},
    value = '',
    onEnterPress = null,
    searchInfoMessage = 'Min_Search_Char_Limit',
    ...rest
}) => {
    const { t } = useTranslation()
    const [searchText, setSearchText] = useState(value)
    const [previousValidLength, setPreviousValidLength] = useState(0)
    const [isFocused, setIsFocused] = useState(false)
    const debouncedValue = useDebounce(searchText)?.trim()
    useEffect(() => {
        if (value === '') {
            setSearchText('')
        }
    }, [value])

    const handleInputChange = (event) => {
        const { value } = event.target
        setSearchText(value)
    }

    useEffect(() => {
        if (
            (!debouncedValue && previousValidLength >= minCharacterLength) ||
            debouncedValue.length >= minCharacterLength
        ) {
            handleSearch(debouncedValue)
            setPreviousValidLength(debouncedValue.length)
        }
    }, [debouncedValue])

    return (
        <>
            {isFocused &&
                !hideSearchInfoMessage &&
                searchText.trim().length < minCharacterLength && (
                    <NotificationRoot type="success" sx={sxNotify}>
                        <Box display="flex" alignItems="center">
                            <Box flex="0.1" display="flex" alignItems="center">
                                <InfoOutline />
                            </Box>
                            <Box flex="1.1">
                                <TextRoot>
                                    <Typography variant="caption">
                                        {t(searchInfoMessage, {
                                            chars: minCharacterLength,
                                        })}
                                    </Typography>
                                </TextRoot>
                            </Box>
                        </Box>
                    </NotificationRoot>
                )}

            <StyledSearchInput
                sx={sx}
                fullWidth
                type="text"
                placeholder={t(`${placeholder}`)}
                value={searchText}
                onChange={handleInputChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => {
                    setIsFocused(false)
                    handleInputBlur()
                }}
                onKeyDown={(e) => {
                    if (e.key === ' ') {
                        e.stopPropagation()
                    }
                    if (
                        e.key === 'Enter' &&
                        searchText.length === 0 &&
                        onEnterPress
                    ) {
                        onEnterPress()
                        setIsFocused(false)
                    }
                }}
                {...rest}
            />
        </>
    )
}

export default ThresholdSearchInput
